import { render } from "./Tab2.vue?vue&type=template&id=6c463cb0&scoped=true"
import script from "./Tab2.vue?vue&type=script&lang=js"
export * from "./Tab2.vue?vue&type=script&lang=js"

import "./Tab2.vue?vue&type=style&index=0&id=6c463cb0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c463cb0"]])

export default __exports__